const ActionCard = require("../../entities/Cards/ActionCard");
const Actions = require("../../Constants/Actions/Actions");
const ByName = require("./ByName");

const classOf = ByName(Actions);

const ActionConverter = (actionName, actionAge) =>
{
    const Class = classOf(actionName);
    return Class === undefined ? null : new ActionCard(new Class(actionAge));
}

module.exports = ActionConverter;
